import Notebook from '@/components/resources/dialog/sandbox/jupyter/Notebook';
import { MutationTree } from 'vuex';
import { IState } from './types';

const mutations: MutationTree<IState> = {
  setNotebookMap(state, tar) {
    const { key, value } = tar;

    state.notebookMap.set(key, { ...state.notebookMap.get(key), ...value });
  }
};

export default mutations;
